export default {
    //AcademyComponent
    customization: 'Passen Sie Ihre Akademie an',
    sections: 'Bereiche der Anpassung',
    // Secciones del menú lateral: cada descripción nombra solo lo que hay en esa pantalla.
    identity: 'Identität',
    identity_description: 'Name, Slogan, Logo und Favicon',
    design: 'Design',
    design_description: 'Farben und Schriftarten',
    home: 'Startseite',
    home_description: 'Kopfzeile, Banner und Beschreibung',
    description_location_help: 'Wo sie erscheint: Mit der Kopfzeile „2-spaltig, Text + Bild“ steht sie neben dem Bild oben auf der Startseite. Mit den Kopfzeilen „Banner in voller Größe“ erscheint sie im Kontaktbereich unten auf der Startseite.',
    menu_section_description: 'Links im Website-Menü',
    contact_social: 'Kontakt und soziale Netzwerke',
    contact_description: 'Kontakt, Netzwerke und eigenes HTML',
    legal_description: 'Datenschutz und Impressum',
    settings: 'Einstellungen',
    settings_description: 'Domain, Sprache und Skripte',
    domain: "Domain",
    brand_logo: "Logo und Marke",
    rrss_contact: "Kontakt und soziale Netzwerke",
    legal: "Rechtliches",
    options: 'Optionen',

    //DomainComponent
    your_domain: "Ihre mybrainspro.com-Domäne",
    example_url_placeholder: 'https://',
    example_2: '.mybrainspro.com',
    info_domain: "Geben Sie die Domain OHNE Symbole (.,-¿?!-$%&/()...), Akzente oder Leerzeichen ein. Sie brauchen www. nicht anzugeben.",
    domain_input: "Domäne mybrainspro.com",
    custom_domain: "Personalisierte Domäne",
    domain_text: 'Domäne',
    info_domain2: "Geben Sie Ihre Domain (www.yourdomain.com) ein, um sie als Ihre Homepage oder als sekundäre Seite (ihredomain.ihredomain.com) zu verwenden.",
    attention: "Achtung",
    info_attention: "Nur für ADVANCED- und PRO-Tarif verfügbar.",
    activate_domain: "Um Ihre Domain bei BrainsPro zu aktivieren: ",
    info_activate_1line: "Besuchen Sie die Plattform, auf der Sie Ihre Domain erworben haben, und suchen Sie nach den DNS-Einstellungen.",
    info_activate_2line: "Fügt Datensatztyp A zu IP: 76.223.11.227 hinzu",
    info_activate_3line: "Bitte beachten Sie, dass es bis zu 48 Stunden dauern kann, bis diese Änderungen wirksam werden und sich in Ihrem DNS verbreiten. Sobald Sie fertig sind, können Sie die neue Adresse Ihrer BrainsPro Online-Akademie verwenden.",
    info_activate_4line: "Das brainspro-Team wird sich mit Ihnen in Verbindung setzen, um Ihnen einige zusätzliche Einträge zu schicken, die Sie in Ihrem DNS platzieren müssen. Mit ihnen erstellen wir Ihre sichere Website (https://).",
    example_academy: 'beispiel-akademie',
    example_domain: 'meineakademie.de',
    //LanguageSelector
    lang: 'Sprache',
    academy_lang: 'Akademie Sprache',
    academy_lang_selector_text: 'Wählen Sie die Sprache Ihrer Akademie',

    //BrandingComponent
    banner: 'Banner',
    brand_academy: "Branding Ihrer Akademie",
    academy_name: "Name der Akademie",
    full_name: "Wählen Sie den vollständigen Namen Ihrer Akademie",
    tagline: "Slogan der Akademie",
    slogan: "Wählen Sie einen Slogan für Ihre Akademie",
    tagline_placeholder: "Schreiben Sie hier Ihren Slogan",
    search: 'Suche',
    my_academy: 'Meine Akademie bei BrainsPro',
    change: 'Ändern Sie',
    insert: 'Einfügen',
    href_custom_academy: 'Mehr über die Personalisierung Ihrer Akademie.',

    //ContactComponent
    description: "Beschreibung",
    web_rrss: "Web und soziale Netzwerke",
    web_blog: "Web oder Blog",
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "Linkedin",
    youtube: "Youtube",
    location: "Standort und steuerliche Daten",
    address_line_1: "Anschrift, Zeile 1",
    address_line_2: "Anschrift, Zeile 2",
    postalcode: "Postleitzahl",
    city: "Stadt",
    province: "Provinz",
    country: "Land",
    company_name: "Name des Unternehmens",
    nif_cif: "MWST.-NUMMER",

    //LegalComponent
    privacy_policy: "Datenschutzbestimmungen",
    text_register: "Zusammenfassender Text für die Benutzerregistrierung",
    user_view_text: "Dieser Text wird bei der Benutzerregistrierung als Zusammenfassung der längeren Version angezeigt, die auf der Seite mit den rechtlichen Hinweisen Ihrer Schule erscheinen wird.",
    privacy_policy_page: "Seite zum Datenschutz",
    privacy_policy_academy_page: "Akademie-Datenschutzerklärung Seite",
    legal_notice: "Rechtlicher Hinweis",
    href_legal: 'Mehr über die rechtlichen Hinweise und die Datenschutzrichtlinie.',

    //Contact
    contact_bloq: 'Kontakt Block',
    html_bloq: 'Fügt einen Html-Block ein, der die Kontaktinformationen begleitet. Wie ein Google Maps Iframe.',

    //Branding
    //BannerBrandingComponent
    upload_banner: 'Laden Sie Ihr Banner hoch',
    image_format: 'PNG, JPG, GIF bis zu 3 MB',
    banner_size_recommendation: 'Empfohlen: ein Panoramabild mit mindestens 1600×600 px. Auf kleinen Bildschirmen wird es vollständig angezeigt; auf großen Bildschirmen wird es zugeschnitten, um die gesamte Breite auszufüllen.',

    //ColorsComponent
    desing_colors: 'Design und Farben',
    header_type: 'Typ der Kopfzeile',
    banner_complete: 'Banner in voller Größe',
    banner_complete_no_text: 'Banner in voller Größe ohne Text',
    columns_text_image: '2-spaltig, Text + Bild',
    banner_info: 'Dadurch wird die Art des Titelbildes geändert, das die Nutzer in Ihrer Akademie sehen.',
    enterprise_color: 'Unternehmensfarbe',
    text_color: 'Textfarbe',

    //FontsComponent
    desing_fonts: 'Typografie',
    fonts_info: 'Wählen Sie die Schriftart, die für jede Textart in Ihrer Akademie verwendet wird.',
    font_h1: 'Haupttitel (H1)',
    font_h2: 'Untertitel (H2)',
    font_h3: 'Abschnittstitel (H3)',
    font_body: 'Fließtext',
    font_default: 'Standard',

    //FaviconComponent
    favicon: 'Favicon',
    favicon_help: 'Symbol, das im Browser-Tab angezeigt wird.',
    upload_favicon: 'Laden Sie Ihr Favicon hoch',
    favicon_format: 'PNG, JPG, GIF bis zu 3 MB',

    //LogoBrandingComponent
    logo: 'Logo',
    logo_help: 'Erscheint im Kopfbereich der Website und auf Zertifikaten.',
    upload_logo: 'Laden Sie Ihr Logo hoch',

    //OptionsComponent
    register_config: 'Registrierung Konfiguration',
    info_button_register: 'Wenn Sie diese Schaltfläche aktivieren, wird die Option zur Registrierung in der Akademie deaktiviert. Dazu müssen sich alle Nutzer über die Brainspro App registrieren.',
    restricted_register: 'Einschränkung der Registrierung',

    //MenuComponent
    menu: 'Menü',
    menu_description: 'Wählen Sie, welche Links im oberen Menü der Website Ihrer Akademie erscheinen und in welcher Reihenfolge.',
    menu_default_notice: 'Sie haben noch keine Einträge hinzugefügt, daher verwendet Ihre Website das Standardmenü. Sobald Sie einen hinzufügen, zeigt das Menü nur die Einträge dieser Liste.',
    add_menu_item: 'Eintrag hinzufügen',
    edit_menu_item: 'Eintrag bearbeiten',
    menu_item_edit: 'Bearbeiten',
    menu_item_type: 'Typ',
    menu_item_type_catalog: 'Katalog',
    menu_item_type_contact: 'Kontakt',
    menu_item_type_page: 'Seite',
    menu_item_type_link: 'Link',
    menu_item_type_home: 'Startseite',
    menu_item_type_home_help: 'Führt zur Startseite Ihrer Akademie.',
    menu_item_type_catalog_help: 'Führt zur Seite mit allen Ihren Kursen.',
    menu_item_type_contact_help: 'Führt zum Kontaktbereich Ihrer Startseite.',
    menu_item_type_link_help: 'Führt zu einer beliebigen Webadresse, die Sie eingeben.',
    menu_item_title: 'Linktext',
    menu_item_add_translations: 'Namen in anderen Sprachen hinzufügen',
    menu_item_hide_translations: 'Namen in anderen Sprachen ausblenden',
    menu_item_translations: 'Name in anderen Sprachen',
    menu_item_translations_example: 'Beispiel: Wenn der Link "Kurse" heißt, können Sie auf Englisch "Courses" schreiben.',
    menu_item_page: 'Seite',
    menu_item_select_page: 'Seite auswählen',
    menu_item_page_invalid: 'Die Seite dieses Eintrags ist nicht mehr verfügbar. Wählen Sie eine andere, um speichern zu können.',
    menu_pages_loading: 'Seiten werden geladen…',
    menu_pages_error: 'Die Seiten der Akademie konnten nicht geladen werden.',
    menu_no_pages: 'Sie haben noch keine Seiten. Schreiben Sie dem Support und wir helfen Ihnen, sie zu erstellen.',
    menu_page_unavailable: 'Seite nicht verfügbar',
    menu_page_unavailable_help: 'Die Seite dieses Eintrags existiert nicht mehr und wird daher nicht auf der Website angezeigt. Bearbeiten Sie ihn, um eine andere zu wählen.',
    menu_item_url: 'URL',
    menu_item_url_help: 'Muss mit https:// oder http:// beginnen.',
    menu_item_visible: 'Auf der Website sichtbar',
    menu_item_hidden: 'Ausgeblendet',
    move_menu_item_up: 'Eintrag nach oben',
    move_menu_item_down: 'Eintrag nach unten',
    drag_menu_item: 'Zum Sortieren ziehen',
    delete_menu_item: 'Menüeintrag löschen',
    delete_menu_item_confirm: '„{title}“ wird aus dem Menü entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
    menu_item_saved: 'Der Menüeintrag wurde gespeichert',
    menu_item_deleted: 'Der Eintrag wurde aus dem Menü entfernt',
    menu_order_saved: 'Die Reihenfolge des Menüs wurde gespeichert',
    menu_order_error: 'Die Reihenfolge des Menüs konnte nicht gespeichert werden. Die vorherige Reihenfolge wurde wiederhergestellt.',
    menu_unexpected_error: 'Beim Menü ist ein unerwarteter Fehler aufgetreten',
    menu_item_name_es: 'Name auf Spanisch',
    menu_item_name_en: 'Name auf Englisch',
    menu_item_name_ca: 'Name auf Katalanisch',
    menu_item_name_de: 'Name auf Deutsch',
    menu_item_name_pt: 'Name auf Portugiesisch',
}